import { useQuery } from "@tanstack/react-query";

// Custom hook to reuse the query logic
const useProjectInfoQuery = (id, queryFn) => {
  return useQuery({
    queryKey: ["projectInfoData", id], // Include `id` in query key
    queryFn: () => queryFn(id), // Pass the query function
    enabled: !!id, // Fetch data only if `id` is defined
  });
};

export default useProjectInfoQuery;
